// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'


import GlobalFun from './router/globalFun.js'// 全局函数
import * as custom from './router/filters.js'// 过滤器
import infiniteScroll from 'vue-infinite-scroll'
import http from './router/http.js' // 拦截器
import ajax from './router/ajax.js'// 全局ajax


//   <!-- css调用 -->
import '../static/css/uiqr.min.css';

import '../static/lib/native/nativeShare.css';

import '../static/css/swiper.min.css';
import '../static/css/pick-pcc.min.1.0.1.css';
import '../static/lib/bootstrap.min.js';
import '../static/lib/swiper.jquery.min.js';
import '../static/lib/jquery.qqFace.js';
import '../static/lib/jquery.share.min.js' ;
import "../static/lib/upload.js";
// import '../static/lib/jsddk.js';
/* 视频播放引入 */
import _XYloadJS from '../static/lib/xiyou.player.js';
import "../static/lib/jquery.bxPlayer.js";

import statistic from './statistic';

import Bridge from '../static/lib/JSbridge.js';
Vue.prototype.$bridge = Bridge;
// import VueBridgeWebview from 'vue-bridge-webview';
// Vue.use(VueBridgeWebview);

// // set default config 
// VueBridgeWebview.config(0,true);

// import VueJsBridge from 'vue-webview-js-bridge';
// Vue.use(VueJsBridge, {
//   debug: true,
//   delay: 200,
//   nativeHandlerName: 'callNativeHandler',
//   mock: false,
//   mockHandler (payload, next) {
//     next(Object.assign({ form: 'native' }, payload))
//   }
// })

// Vue.prototype.$bridge = VueJsBridge;
//import Bridge from '../static/lib/bridge.js';
//Vue.prototype.$bridge = Bridge;






// import { Cascader } from 'element-ui'
// Vue.use(Cascader)
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole);

Vue.use(infiniteScroll);
Vue.use(GlobalFun);
Vue.use(VueLazyload);

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

//ajax请求
global.API = ajax;
global._XYVideoPlayer = _XYloadJS
Vue.config.productionTip = false;
Vue.prototype.$http = http;

var that = this
//动态添加首页title
router.beforeEach((to, from, next) => {
  //添加mete
  let metas = $("head").children("meta");
  if (to.meta.keywords) {
    metas[1].content = to.meta.keywords;
  }
  //添加title
  document.title = to.meta.title;

  // statistic(to,from);

  next();
})
//统计
router.afterEach((to, from) => {
  // ...
  statistic(to,from);

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js